module.exports = __webpack_public_path__ + "img/Icons-Job Alert_disabled.1a54baea.svg";